import {createElement, Component, PropTypes, cloneElement, isValidElement} from 'rlink-react';
import {findDOMNode} from 'react-dom';
import isSubclassOf from 'rlink-type-utils/isSubclassOf';
import {FormattedMessage} from 'react-intl';
export default class TooltipContainer extends Component {

  componentDidMount () {
    this._nextFrame = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : cb => setTimeout(cb, 1000 / 30);
    this._onMouseMove = ev => {
      let hasNextFrameHandler = false;
      if (!hasNextFrameHandler) {
        this._nextFrame(() => {
          this._lastKnownMouseX = ev.clientX;
          this._lastKnownMouseY = ev.clientY;
          if (this.tooltipContent) {
            this.followMouse(ev);
          }
          hasNextFrameHandler = false;
        });
        hasNextFrameHandler = true;
      }
    };

    document.addEventListener('mousemove', this._onMouseMove);
  }

  componentWillUnmount () {
    document.removeEventListener('mousemove', this._onMouseMove);
  }

  followMouse (ev) {
    let tooltip = this.tooltipContent;
    if (tooltip) {
      this.transformCoordinatesInBounds(ev);
      if (!tooltip.dataset.loaded) {
        setTimeout(() => {
          tooltip.style.transition = `${(tooltip.style.transition)
            ? `${tooltip.style.transition}, `
            : ''}-webkit-transform 0.1s ease-out`;
          tooltip.dataset.loaded = true;
        }, 100);
      }
    }
  }

  transformCoordinatesInBounds (ev = null) {
    let tooltip = this.tooltipContent;
    if (tooltip) {
      let mouseX = (ev)
        ? ev.clientX
        : this._lastKnownMouseX;

      let mouseY = (ev)
        ? ev.clientY
        : this._lastKnownMouseY;

      let tooltipDimensions = {height: tooltip.offsetHeight, width: tooltip.offsetWidth};
      let mouseOffsetY = this.props.mouseOffsetY;
      let padding = this.props.padding;

      let destinationX = mouseX - (tooltip.offsetWidth / 2);
      let destinationY = mouseY + mouseOffsetY;

      if (tooltipDimensions.height + destinationY > window.innerHeight - padding) {
        destinationY = mouseY - tooltipDimensions.height - mouseOffsetY;
      }

      if (tooltipDimensions.width + destinationX > window.innerWidth - padding) {
        destinationX = window.innerWidth - tooltipDimensions.width - padding;
      }

      if (destinationX < padding) {
        destinationX = padding;
      }

      if (destinationY < padding) {
        destinationY = padding;
      }

      tooltip.style.transform = `translate(${destinationX}px,${destinationY}px)`;
      tooltip.style['-webkit-transform'] = `translate(${destinationX}px,${destinationY}px)`;
      tooltip.style.opacity = 1;
    }
  }

  render () {
    let content = this.props.children;
    if (!content) {
      return null;
    }

    if (!isValidElement(content) || (typeof content.type === 'function' && isSubclassOf(FormattedMessage, content.type))) {
      content = <div className="tooltip">{content}</div>;
    }
    return cloneElement(content, {
      ref: element => {
        this.tooltipContent = findDOMNode(element);
        this.transformCoordinatesInBounds();
      }});
  }
}

TooltipContainer.propTypes = {
  children: PropTypes.node,
  padding: PropTypes.number,
  mouseOffsetY: PropTypes.number,
};

TooltipContainer.defaultProps = {
  mouseOffsetY: 30,
  padding: 20,
};



// WEBPACK FOOTER //
// ./lib/rlink-tooltips/TooltipContainer.jsx